export { default as isUrl } from 'is-url-superb'
